import React from "react";

import PropTypes from "prop-types";
import { Button } from "antd";

const PreviousButton = ({handleClick,isActive}) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Your other header content */}
      <div style={{ marginLeft: "10px" }}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          marginTop:'10px',
          minHeight:'40px'
        }}
      >
        <Button type="secondary"  onClick={handleClick} style={{minHeight:'60px',backgroundColor:isActive?'red':'rgba(0, 103, 138, 0.70)'}} disabled={!isActive??true}>
        <span style={{ color: "#FFF", padding: "5px",fontSize:'15px',fontWeight:'700' }}>Restart Questions</span>
        </Button>
      </div>
    </div>
  );
};

PreviousButton.propTypes = {
  icon: PropTypes.element,
  isActive: PropTypes.bool,
  handleClick: PropTypes.func
};

export default PreviousButton;
